import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';

export const statusesForFetchingLoanDecision = [
  ChecklightSessionStatus.FINALIZE_STIPS,
  ChecklightSessionStatus.FUNDED,
  ChecklightSessionStatus.REVIEWING_DOCUMENTS,
  ChecklightSessionStatus.SIGN_CONTRACTS,
  ChecklightSessionStatus.WAITING_ON_FUNDING,
];
